import { updatePlayer } from "../api/requests/player.requests.js";
import { StatisticsStorage } from "../storage/statistics_storage.js";
import { CumulativeBoosterID } from "./cumulative_booster_id.js";

export function isBoosterTutorialCompleted( booster_id: CumulativeBoosterID ): boolean
{
  return StatisticsStorage.load().completed_booster_tutorials.includes( booster_id );
}

export function completeBoosterTutorial( booster_id: CumulativeBoosterID ): void
{
  const stats = StatisticsStorage.load();
  if ( stats.completed_booster_tutorials.includes( booster_id ) )
    return;

  const completed = [
    ...stats.completed_booster_tutorials,
    booster_id,
  ];

  void updatePlayer( { completed_booster_tutorials: completed } )
    .catch( e => console.warn( '[BoosterTutorial] server sync failed', e ) );

  StatisticsStorage.update( {
    completed_booster_tutorials: completed,
    // Keep the legacy field for compatibility with existing saves/builds.
    ...( booster_id === CumulativeBoosterID.BigBall
      ? { big_ball_tutorial_completed: true }
      : {} ),
  } );
}
